import type { QueryKey } from '@tanstack/react-query';

import { useQuery } from '../../../ReactQuery';
import { post } from '../../../redux/api';
import type { PolicyRule } from '../../../../typings/api';
import type { LicensingRule, PolicyId } from '../../../types';

const postPolicyRule = (policyId: PolicyId, rule: LicensingRule) => {
  return post<Partial<LicensingRule>, PolicyRule>(`/api/policies/${policyId}/rules`, rule);
};

const getQueryKeyForPolicyRule = (policyId: PolicyId, rule: Partial<LicensingRule>): QueryKey => [
  'policyRule',
  policyId,
  rule.licenseId,
];

/**
 * hook for creating one policy rule
 */
export default function useCreatePolicyRule(policyId: PolicyId, rule: LicensingRule) {
  return useQuery<PolicyRule>({
    queryKey: getQueryKeyForPolicyRule(policyId, rule),
    queryFn: () => postPolicyRule(policyId, rule),
  });
}
